export const SET_SELECTED_ANSWERS = 'SET_SELECTED_ANSWERS';
  
  export const setSelectedAnswers = (answers) => ({
    type: SET_SELECTED_ANSWERS,
    payload: answers,
  });